import {MiddlewareType} from 'middlewares'
import {OVERLAY_HIDE, OVERLAY_SHOW} from 'modules/overlay/actions'
import {OVERLAY_IDS} from 'modules/overlay/constants'
import Router from 'next/router'

import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  AnalyticsContext,
  Category,
  Entity,
  Page
} from '@vio/core/src/analytics/types/Events'
import {buildUrl, parseQueryString} from '@vio/core/src/utils/url'

import {Component} from './analytics'

const middleware: MiddlewareType = store => next => action => {
  const {dispatch} = store

  next(action)

  switch (action.type) {
    case OVERLAY_SHOW: {
      const {id} = action.params
      if (action.ignoreHistory) break
      const search = parseQueryString(location.search)
      Router.push(
        buildUrl(
          location.pathname,
          {...search, overlay: id},
          {
            arrayFormat: 'indices'
          }
        ),
        undefined,
        {shallow: true}
      )

      if (id === OVERLAY_IDS.preferences) {
        dispatch(
          trackEvent({
            category: Category.System,
            entity: Entity.PreferencesOverlay,
            action: Action.Displayed,
            page: Page.Payment
          })
        )
      }

      break
    }

    case OVERLAY_HIDE: {
      const {offerEventContext, id} = action.params
      if (action.ignoreHistory) break

      Router.back()

      if (id === OVERLAY_IDS.preferences) {
        dispatch(
          trackEvent({
            category: Category.System,
            entity: Entity.OverlayClose,
            action: Action.Succeeded,
            page: Page.Payment,
            component: Component.Preferences,
            analyticsContext: {
              [AnalyticsContext.OfferContext]: offerEventContext
            }
          })
        )
      }

      break
    }

    default:
      break
  }
}

export default middleware
